import script from "./FirstRound.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstRound.vue?vue&type=script&setup=true&lang=js"

import "./FirstRound.vue?vue&type=style&index=0&id=7569c019&lang=css"

const __exports__ = script;

export default __exports__